// --- NEW FILE: apps/website/src/stores/ui/goalEditor.slice.ts ---

import type { StateCreator } from 'zustand';
import type { Goal } from '@dopomogai/types';
import { NEW_GOAL_TEMPLATE } from './templates';

export interface GoalEditorState {
  isOpen: boolean;
  editingGoal: Goal | null;
}

export interface GoalEditorSlice {
  goalEditor: GoalEditorState;
  openGoalEditor: (goal: Goal | null) => void;
  closeGoalEditor: () => void;
  updateEditingGoal: (data: Partial<Goal>) => void;
}

export const createGoalEditorSlice: StateCreator<GoalEditorSlice, [], [], GoalEditorSlice> = (set) => ({
  goalEditor: {
    isOpen: false,
    editingGoal: null,
  },
  openGoalEditor: (goal) => set({
    goalEditor: {
      isOpen: true,
      editingGoal: goal ? { ...goal } : { ...NEW_GOAL_TEMPLATE },
    }
  }),
  closeGoalEditor: () => set({ goalEditor: { isOpen: false, editingGoal: null } }),
  updateEditingGoal: (data) => set((state) => {
    if (!state.goalEditor.editingGoal) return state;
    return {
      goalEditor: {
        ...state.goalEditor,
        editingGoal: { ...state.goalEditor.editingGoal, ...data },
      }
    };
  }),
});